(() => {
  'use strict';

  const observers = new Map();
  const widgetSelector = 'koala-gifts-reward-showcase.koala-element--app-embed-block';

  function arrangeAddons(container) {
    if (!container.isConnected) return;

    container.querySelectorAll('product-form form').forEach((form) => {
      const children = Array.from(form.children);
      const buttons = children.find((child) => child.matches('.product-form__buttons'));
      if (!buttons) return;

      const widgets = children.filter((child) => child.matches(widgetSelector));
      let anchor = buttons;

      widgets.reverse().forEach((widget) => {
        if (widget.nextElementSibling !== anchor) anchor.before(widget);
        widget.classList.add('hs-product-addon');
        anchor = widget;
      });
    });
  }

  function initialize(scope) {
    if (!document.body.classList.contains('hs-design')) return;

    scope.querySelectorAll('.section-main-product .product__info-container').forEach((container) => {
      if (observers.has(container)) return;

      let scheduled = false;
      const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          arrangeAddons(container);
        });
      });

      arrangeAddons(container);
      observer.observe(container, { childList: true, subtree: true });
      observers.set(container, observer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    observers.forEach((observer, container) => {
      if (event.target.contains(container)) {
        observer.disconnect();
        observers.delete(container);
      }
    });
  });
})();

